
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(548|841)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
